module.exports = __webpack_public_path__ + "site/img/processing_en-01.26edf4eb.jpg";